import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const parseDate = (date: string): Date => {
  return dayjs(date, 'YYYY-MM-DDThh:mm:ss.SSSZ').toDate();
};
